import type { ReviewedLibraryIdentity } from './library-identity-types';

export const LIBRARY_BACK_02: ReviewedLibraryIdentity[] = [
  {
    "id": "library-threeway-bent-barbell-row",
    "name": "俯身双臂绳索划船",
    "group": "back",
    "subCategory": "thickness",
    "equipment": "cable",
    "pattern": "俯身双臂绳索水平拉",
    "legacyIds": [
      "threeway-bent-barbell-row"
    ],
    "sourceId": "threeway-bent-barbell-row",
    "targetMuscles": [
      "背阔肌",
      "菱形肌",
      "斜方肌中下部"
    ],
    "evidence": "主线程复核旧教学抽帧：直杆连接低位滑轮，实际为绳索而非杠铃；只纠正标准库"
  },
  {
    "id": "library-personal-s2-straight-arm-pulldown",
    "name": "绳索直臂下压",
    "group": "back",
    "subCategory": "width",
    "equipment": "cable",
    "pattern": "直臂肩伸",
    "legacyIds": [
      "personal-s2-straight-arm-pulldown",
      "fanjue-straight-arm-pulldown"
    ],
    "sourceId": "course-20261008-four-way-02-05",
    "targetMuscles": [
      "背阔肌",
      "大圆肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s2-single-arm-cable-row",
    "name": "单臂绳索划船",
    "group": "back",
    "subCategory": "thickness",
    "equipment": "cable",
    "pattern": "单臂绳索水平拉",
    "legacyIds": [
      "personal-s2-single-arm-cable-row"
    ],
    "sourceId": "course-20261008-personal-02-05",
    "targetMuscles": [
      "背阔肌",
      "菱形肌",
      "斜方肌中下部"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-wide-pulldown",
    "name": "宽握高位下拉",
    "group": "back",
    "subCategory": "width",
    "equipment": "cable",
    "pattern": "宽握垂直拉",
    "legacyIds": [
      "fanjue-wide-pulldown"
    ],
    "sourceId": "course-20261008-fanjue-plan-01-03",
    "targetMuscles": [
      "背阔肌",
      "大圆肌",
      "肱二头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-prone-machine-row",
    "name": "俯身器械划船",
    "group": "back",
    "subCategory": "thickness",
    "equipment": "machine",
    "pattern": "俯身器械水平拉",
    "legacyIds": [
      "fanjue-prone-machine-row"
    ],
    "sourceId": "course-20261008-fanjue-plan-02-01",
    "targetMuscles": [
      "背阔肌",
      "菱形肌",
      "斜方肌中下部"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-supinated-straight-arm-pulldown",
    "name": "反握绳索直臂下压",
    "group": "back",
    "subCategory": "width",
    "equipment": "cable",
    "pattern": "反握直臂肩伸",
    "legacyIds": [
      "fanjue-supinated-straight-arm-pulldown"
    ],
    "sourceId": "course-20261008-fanjue-plan-02-03",
    "targetMuscles": [
      "背阔肌",
      "大圆肌"
    ],
    "evidence": "对应上传素材错配，标准动作保留但不引用反手高位下拉冒充"
  },
  {
    "id": "library-fanjue-seated-machine-row",
    "name": "坐姿器械划船",
    "group": "back",
    "subCategory": "thickness",
    "equipment": "machine",
    "pattern": "坐姿器械水平拉",
    "legacyIds": [
      "fanjue-seated-machine-row"
    ],
    "sourceId": "course-20261008-fanjue-plan-02-02",
    "targetMuscles": [
      "背阔肌",
      "菱形肌",
      "斜方肌中下部"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-lat-pulldown",
    "name": "正握高位下拉",
    "group": "back",
    "subCategory": "width",
    "equipment": "cable",
    "pattern": "常规正握垂直拉",
    "legacyIds": [
      "fanjue-lat-pulldown"
    ],
    "sourceId": "course-20261008-four-way-02-02",
    "targetMuscles": [
      "背阔肌",
      "大圆肌",
      "肱二头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  }
];
